module.exports = __webpack_public_path__ + "img/26.88295b6d.jpg";